import type { PreviewLocale, PreviewMessages, PreviewOptions } from "./types";

export const defaultMessages: Record<PreviewLocale, PreviewMessages> = {
  "zh-CN": {
    loading: "正在加载预览...",
    unsupportedTitle: "当前文件暂不支持在线预览",
    downloadTitle: "当前文件可下载后查看",
    downloadFile: "下载文件",
    file: "文件",
    unnamedFile: "未命名文件",
    format: "格式",
    unknown: "未知",
    mime: "MIME",
    undeclared: "未声明",
    size: "大小",
    source: "来源",
    remoteUrl: "远程 URL",
    localFile: "本地/内存文件",
    textPlainLanguage: "纯文本",
    textLineCount: "{count} 行",
    textWrap: "换行",
    textCopy: "复制",
    textCopied: "已复制",
    textCopyFailed: "复制失败",
    textDownload: "下载",
    textDownloadReady: "下载已准备",
    textLargeFileNotice: "文件较大，当前展示前 {size}，复制和下载仍会使用完整内容。",
    textHighlightSkipped: "内容较大，已跳过语法高亮以保持滚动流畅。",
    textPreviewFailedTitle: "文本预览失败",
    textPreviewFailedMessage: "无法读取该文本内容，可能是远程文件不可访问或响应状态异常。",
    textOpenOriginal: "打开原文件",
    lrcPreviewMode: "LRC 预览模式",
    lrcDisplayMode: "展示模式",
    lrcAnnotatedMode: "美观模式",
    lrcSourceMode: "源码模式",
    lrcWordTimestamp: "逐字时间",
    lrcMale: "男声",
    lrcFemale: "女声",
    lrcDuet: "合唱",
    lrcAuthor: "词曲",
    lrcLyricist: "作词",
    lrcLrcBy: "歌词制作",
    lrcAlbum: "专辑",
    lrcLength: "时长",
    lrcOffset: "时间偏移",
    lrcTool: "制作工具",
    lrcVersion: "版本",
    lrcTrackInformation: "音乐作品信息",
    lrcEmpty: "没有可展示的歌词内容。",
    officeLegacyConversionTitle: "Office 转换提示",
    officeLegacyBinaryNotice:
      "属于旧版 Microsoft Office 二进制格式，浏览器内无法高保真解析；当前仅展示可信文本片段和结构指纹，完整排版建议接入 LibreOffice/OnlyOffice 服务端转换为 PDF/HTML。",
    officeLegacyMetaFormatType: "格式类型",
    officeLegacyMetaFileStructure: "文件结构",
    officeLegacyOleDetected: "检测到 OLE Compound File 签名",
    officeLegacyOleMissing: "未检测到标准 OLE 签名，按原始二进制尝试提取",
    officeLegacyMetaTextFragments: "文本片段",
    officeLegacyTextFragmentCount: "{count} 段",
    officeLegacyMetaParseStatus: "解析状态",
    officeLegacyReadableFragments: "可读文本片段",
    officeLegacyNoText: "未提取到稳定可读文本。该文件可能经过压缩、加密，或文本编码无法在浏览器端可靠识别；请使用服务端 LibreOffice/OnlyOffice 转换后预览。",
    officeLegacyWordParseFailed: "Word 二进制解析失败：{message}",
    officeSheetParseFailed: "表格解析失败：{message}",
    officeUnsupportedTitle: "Office 基础预览",
    officeUnsupportedLegacyMessage:
      "该格式属于老二进制或专有格式，浏览器内无法可靠解析；建议接入 LibreOffice/OnlyOffice 服务端转换为 PDF/HTML 后预览。",
    officeUnsupportedGenericMessage: "该格式通常需要服务端转换或专用解析器才能高保真预览。",
    officeUnsupportedIntro: "已进入 Office 插件。{message}",
    officeUnsupportedSupportedFormats:
      "当前版本优先支持 docx、rtf、odt/fodt、xlsx/xls/csv/ods、pptx/ppsx、odp/fodp 的基础内容预览。",
    officeErrorWithMessage: "解析器返回：{message}",
    officeErrorWithoutMessage: "解析器未返回具体错误信息。",
    officeConvertedTitle: "Office 高保真转换预览",
    officeConvertedPdfFailed: "Office 转换后的 PDF 无法预览",
    pdfEncryptedTitle: "PDF 已加密，无法在线预览",
    pdfEncryptedMessage: "请下载后使用密码打开，或上传解密后的 PDF 文件。",
    pdfPreviewFailedTitle: "PDF 预览失败",
    pdfCorruptedMessage: "该 PDF 文件可能已损坏或格式无效。",
    pdfCannotLoadMessage: "当前浏览器无法加载该 PDF。",
    pdfDownload: "下载 PDF",
    pdfPageLoading: "页面 {page} 加载中...",
    pdfPageEmpty: "该页没有检测到可显示的 PDF 兼容内容。若这是 Illustrator/AI 文件，可能只包含私有编辑数据，建议导出为 PDF/SVG/PNG 后预览。",
    pdfPageRenderFailed: "无法渲染该页面。该页可能包含浏览器 PDF 引擎暂不支持的图形、字体或压缩特性。",
    pdfPreviousPage: "上一页",
    pdfNextPage: "下一页",
    pdfPageInput: "当前页码",
    pdfPagePosition: "/ {total}",
    pdfPageLabel: "第 {page} 页",
    pdfSummaryPages: "页数",
    pdfSummaryPageSizes: "页面尺寸",
    pdfSummaryFit: "适配",
    pdfSummaryActualSize: "原始大小",
    pdfSummaryFitWidth: "适合宽度",
    pdfSummaryZoom: "缩放",
    imagePreviewFailedTitle: "图片预览失败",
    imagePreviewFailedMessage: "当前浏览器无法直接显示该图片，文件可能已损坏或编码暂不受支持。",
    imageDownload: "下载图片",
    imageZoomOut: "缩小",
    imageZoomIn: "放大",
    imageRotate: "旋转图片",
    imageReset: "重置图片视图"
  },
  "en-US": {
    loading: "Loading preview...",
    unsupportedTitle: "Preview is not available for this file",
    downloadTitle: "This file can be downloaded and opened locally",
    downloadFile: "Download file",
    file: "File",
    unnamedFile: "Untitled file",
    format: "Format",
    unknown: "Unknown",
    mime: "MIME",
    undeclared: "Not declared",
    size: "Size",
    source: "Source",
    remoteUrl: "Remote URL",
    localFile: "Local or in-memory file",
    textPlainLanguage: "plain text",
    textLineCount: "{count} lines",
    textWrap: "Wrap",
    textCopy: "Copy",
    textCopied: "Copied",
    textCopyFailed: "Copy failed",
    textDownload: "Download",
    textDownloadReady: "Download ready",
    textLargeFileNotice: "Large file, showing the first {size}. Copy and download still use the full content.",
    textHighlightSkipped: "Large content, syntax highlighting was skipped to keep scrolling smooth.",
    textPreviewFailedTitle: "Text preview failed",
    textPreviewFailedMessage: "Unable to read this text content. The remote file may be unreachable or returned an invalid response.",
    textOpenOriginal: "Open original file",
    lrcPreviewMode: "LRC preview mode",
    lrcDisplayMode: "Lyrics mode",
    lrcAnnotatedMode: "Annotated mode",
    lrcSourceMode: "Source mode",
    lrcWordTimestamp: "Word timestamp",
    lrcMale: "Male vocal",
    lrcFemale: "Female vocal",
    lrcDuet: "Duet",
    lrcAuthor: "Written by",
    lrcLyricist: "Lyrics by",
    lrcLrcBy: "LRC by",
    lrcAlbum: "Album",
    lrcLength: "Length",
    lrcOffset: "Timing offset",
    lrcTool: "Created with",
    lrcVersion: "Version",
    lrcTrackInformation: "Music information",
    lrcEmpty: "No lyrics to display.",
    officeLegacyConversionTitle: "Office conversion guidance",
    officeLegacyBinaryNotice:
      "belongs to a legacy Microsoft Office binary format that cannot be rendered with high fidelity in the browser. The preview shows trusted text fragments and structural fingerprints; use a LibreOffice/OnlyOffice server conversion to PDF/HTML for complete layout fidelity.",
    officeLegacyMetaFormatType: "Format type",
    officeLegacyMetaFileStructure: "File structure",
    officeLegacyOleDetected: "OLE Compound File signature detected",
    officeLegacyOleMissing: "No standard OLE signature detected; extracting from raw binary data",
    officeLegacyMetaTextFragments: "Text fragments",
    officeLegacyTextFragmentCount: "{count} fragments",
    officeLegacyMetaParseStatus: "Parse status",
    officeLegacyReadableFragments: "Readable text fragments",
    officeLegacyNoText: "No stable readable text was extracted. The file may be compressed, encrypted, or use text encoding that cannot be reliably recognized in the browser; use LibreOffice/OnlyOffice server conversion before previewing.",
    officeLegacyWordParseFailed: "Word binary parse failed: {message}",
    officeSheetParseFailed: "Spreadsheet parse failed: {message}",
    officeUnsupportedTitle: "Office basic preview",
    officeUnsupportedLegacyMessage:
      "This is a legacy binary or proprietary format that cannot be reliably parsed in the browser; convert it to PDF/HTML through LibreOffice/OnlyOffice on the server before previewing.",
    officeUnsupportedGenericMessage: "This format usually needs server-side conversion or a dedicated parser for high-fidelity preview.",
    officeUnsupportedIntro: "is handled by the Office plugin. {message}",
    officeUnsupportedSupportedFormats:
      "This version prioritizes basic previews for docx, rtf, odt/fodt, xlsx/xls/csv/ods, pptx/ppsx, and odp/fodp files.",
    officeErrorWithMessage: "Parser returned: {message}",
    officeErrorWithoutMessage: "Parser did not return a specific error.",
    officeConvertedTitle: "High-fidelity Office conversion preview",
    officeConvertedPdfFailed: "The converted Office PDF could not be previewed",
    pdfEncryptedTitle: "This PDF is encrypted and cannot be previewed online",
    pdfEncryptedMessage: "Download and open it with the password, or upload a decrypted PDF file.",
    pdfPreviewFailedTitle: "PDF preview failed",
    pdfCorruptedMessage: "The PDF may be corrupted or use an invalid format.",
    pdfCannotLoadMessage: "This browser could not load the PDF.",
    pdfDownload: "Download PDF",
    pdfPageLoading: "Loading page {page}...",
    pdfPageEmpty: "No displayable PDF-compatible content was detected on this page. If this is an Illustrator/AI file, export it as PDF, SVG, or PNG before previewing.",
    pdfPageRenderFailed: "This page could not be rendered. It may contain graphics, fonts, or compression features that the browser PDF engine does not support.",
    pdfPreviousPage: "Previous page",
    pdfNextPage: "Next page",
    pdfPageInput: "Current page",
    pdfPagePosition: "/ {total}",
    pdfPageLabel: "Page {page}",
    pdfSummaryPages: "Pages",
    pdfSummaryPageSizes: "Page sizes",
    pdfSummaryFit: "Fit",
    pdfSummaryActualSize: "Actual size",
    pdfSummaryFitWidth: "Fit width",
    pdfSummaryZoom: "Zoom",
    imagePreviewFailedTitle: "Image preview failed",
    imagePreviewFailedMessage: "This browser cannot display the image. The file may be corrupted or use an unsupported encoding.",
    imageDownload: "Download image",
    imageZoomOut: "Zoom out",
    imageZoomIn: "Zoom in",
    imageRotate: "Rotate image",
    imageReset: "Reset image view"
  }
};

export function resolveMessages(options: Pick<PreviewOptions, "locale" | "messages">): PreviewMessages {
  return {
    ...defaultMessages[options.locale || "en-US"],
    ...options.messages
  };
}

export function formatPreviewMessage(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => String(values[key] ?? match));
}
